import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import './Markets.css';

// Import icons and images
import { FiArrowLeft, FiArrowRight, FiExternalLink } from 'react-icons/fi';
import grainsImg from '../../assets/images/commodity-grains.jpg';
import spicesImg from '../../assets/images/commodity-spices.jpg';
import sugarImg from '../../assets/images/commodity-sugar.jpg';
import pulsesImg from '../../assets/images/commodity-pulses.jpg';
import vegetablesImg from '../../assets/images/commodity-vegetables.jpg'; // Assuming you have this image
import oilseedsImg from '../../assets/images/commodity-oilseeds.jpg'; // Assuming you have this image

// --- UPDATED DATA: Added 'subItems' arrays ---
const commodityData = [
  {
    title: 'Grains',
    image: grainsImg,
    subItems: ['Wheat', 'Rice', 'Maize', 'Barley', 'Bajra'],
  },
  {
    title: 'Spices',
    image: spicesImg,
    subItems: ['Chilli', 'Turmeric', 'Coriander', 'Cumin'],
  },
  {
    title: 'Sugar',
    image: sugarImg,
    // No sub-items for this one
  },
  {
    title: 'Pulses',
    image: pulsesImg,
    subItems: ['Bengal Gram', 'Urad', 'Moong', 'Masoor', 'Tur', 'Pea'],
  },
  {
    title: 'Vegetables',
    image: vegetablesImg,
    subItems: ['Tomato', 'Potato','Onion']
  },
  {
    title: 'Oilseeds',
    image: oilseedsImg,
    subItems: ['Soybean', 'Rapeseed', 'Cotton', 'Groundnut'],
  },
];

const CommodityExplorer = () => {
  const scrollContainerRef = useRef(null);

  const scroll = (direction) => {
    if (scrollContainerRef.current) {
      const scrollAmount = direction === 'left' ? -300 : 300;
      scrollContainerRef.current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  };

  return (
    <section className="commodity-explorer-section">
      <div className="section-header">
        <h2>Explore The Markets</h2>
        <div className="header-line"></div>
      </div>
      <p className="section-subtitle">
        CRISHI is a gateway to the world of insights spanning diverse crop markets, providing 800+ price assessments across 40+ countries.
      </p>

      <div className="commodity-carousel-container">
        <button className="scroll-arrow left" onClick={() => scroll('left')}><FiArrowLeft /></button>
        
        <div className="commodity-scroller" ref={scrollContainerRef}>
          {commodityData.map((commodity, index) => (
            <div key={index} className="commodity-card" style={{ backgroundImage: `url(${commodity.image})` }}>
              
              {/* --- NEW: The hidden list that appears on hover --- */}
              {commodity.subItems && (
                <div className="sub-items-list">
                  <h4>{commodity.title}</h4>
                  <ul>
                    {commodity.subItems.map((item, subIndex) => <li key={subIndex}>{item}</li>)}
                  </ul>
                </div>
              )}

              <div className="commodity-card-overlay">
                <span className="commodity-card-title">{commodity.title}</span>
                <a href="/" className="external-link-icon" aria-label={`Explore ${commodity.title}`}>
                  <FiExternalLink />
                </a>
              </div>
            </div>
          ))}
        </div>
        
        <button className="scroll-arrow right" onClick={() => scroll('right')}><FiArrowRight /></button>
      </div>

      <div className="explore-more-container">
        <Link to="/markets">
          <button className="explore-more-btn">Explore more</button>
        </Link>
      </div>
    </section>
  );
};

export default CommodityExplorer;